import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authV2 = createApi({
  reducerPath: "authV2",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_APIURL,
  }),
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    return headers;
  },
  tagTypes: ["AuthV2"],
  endpoints: (builder) => ({
    requestForgotPassword: builder.mutation({
      query: ({ requestingEmail }) => ({
        url: `/ziyl/RequestForgotPasswordfinxp`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          email: requestingEmail,
        },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ requestingEmail, password, resetToken }) => ({
        url: `/ziyl/resetPasswordfinxp`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          email: requestingEmail,
          password,
          password_confirmation: password,
          token: resetToken,
        },
      }),
    }),
    confirmNewDevice: builder.mutation({
      query: (bodyParams) => ({
        url: `/ziyl/auth/confirm-new-device`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyParams,
      }),
    }),
    confirmNewGeoLocation: builder.mutation({
      query: (bodyParams) => ({
        url: `/ziyl/auth/confirm-geolocation`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyParams,
      }),
    }),
    signInV2: builder.mutation({
      query: (bodyParams) => ({
        url: `/ziyl/auth/login-2FA`, // -- as per santi, we should use this endpoint for now and go back to `ziyl/auth/login` later
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyParams,
      }),
    }),
    signOut: builder.mutation({
      query: ({ token }) => ({
        url: `/ziyl/auth/logout`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    registerQRCode: builder.mutation({
      query: ({ email, token }) => ({
        url: `/ziyl/registration/2FA/qr`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    confirmQRCode: builder.mutation({
      query: ({ token, otp, twoFactorAuthenticator }) => ({
        url: `/ziyl/registration/2FA/confirm`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: {
          code: otp,
          twoFactorAuthenticator: twoFactorAuthenticator,
        },
      }),
    }),
    verifyQRCode: builder.mutation({
      query: ({ token, otp, twoFactorAuthenticator }) => ({
        url: `/ziyl/auth/2FA/verify`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: {
          code: otp,
          twoFactorAuthenticator,
        },
      }),
    }),
    authenticationSMSTriggerCode: builder.mutation({
      query: ({ email, token, finxpToken, authType }) => ({
        url: `/ziyl/auth/2FA/send-sms`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          AuthorizationFinxp: `Bearer ${finxpToken}`,
        },
        body: {
          email,
          sender: authType,
        },
      }),
    }),
  }),
});

export const {
  useRequestForgotPasswordMutation,
  useResetPasswordMutation,
  useConfirmNewDeviceMutation,
  useConfirmNewGeoLocationMutation,
  useSignInV2Mutation,
  useSignOutMutation,
  useRegisterQRCodeMutation,
  useConfirmQRCodeMutation,
  useVerifyQRCodeMutation,
  useAuthenticationSMSTriggerCodeMutation,
} = authV2;
